// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bolt-solid';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M13.142 8.508a.724.724 0 0 0-.617-1.104h-2.463V1.03L4.859 9.488a.724.724 0 0 0 .617 1.104h2.463v6.375z'
  />
);

export const viewBox = '0 0 18 18';
